
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqwj0nTDMkzveXU_45aQIidJ2l2eLAFjR9PIJYxzlwiPwV8Meta } from "/codebuild/output/src1259003470/src/src/pages/faq.vue?macro=true";
import { default as menuHWauu1q9jBQKos7h_45PpjzhEEZ9va5midatwWyTYi3_QMeta } from "/codebuild/output/src1259003470/src/src/pages/menu.vue?macro=true";
import { default as indexxXYQvohAEj6SP1l5IahKOw4VxPIy2LDiavm_u_pNTDIMeta } from "/codebuild/output/src1259003470/src/src/pages/index.vue?macro=true";
import { default as contactEwATKgwjTnaQf_vez8i68LzzJdBT33daVlLWHpjB160Meta } from "/codebuild/output/src1259003470/src/src/pages/contact.vue?macro=true";
import { default as tutorialOu7fyB38Hm2o8yaH9_45tVCf4GHnF1eynlycZzYOJt3QsMeta } from "/codebuild/output/src1259003470/src/src/pages/tutorial.vue?macro=true";
import { default as agreementPAADXT8eYjJIJ77aqs2F0pO0zorO3eFeL5TrRclDcUoMeta } from "/codebuild/output/src1259003470/src/src/pages/agreement.vue?macro=true";
import { default as about_45passK8NAAjDGKiujPrlhJSH96_45h6JjthszBMgUVlHlUkIYYMeta } from "/codebuild/output/src1259003470/src/src/pages/about-pass.vue?macro=true";
import { default as indexvsjXcaB94ezIf_45BWfXfs7cbfML0GXVDhi572NUvknfoMeta } from "/codebuild/output/src1259003470/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93SH_AsLMOfFreTwgi529kRnzN_VrztSwWy9P6VyxjdfAMeta } from "/codebuild/output/src1259003470/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceePc8kHIzPvY7BYARgAPkJpEmai50Q4D_45KnKlWHd6uo0Meta } from "/codebuild/output/src1259003470/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93QhrXsHpwBznzuaNtZDcT5tK0nxiAGVMKXb17dv2rn48Meta } from "/codebuild/output/src1259003470/src/src/pages/notice/[id].vue?macro=true";
import { default as indexCfNVJPVTnvRE_45lioEIBmE33zvDy3Kl1F_45i3T8EHqsAIMeta } from "/codebuild/output/src1259003470/src/src/pages/coupon/index.vue?macro=true";
import { default as indexZHh34K9wc5o_s6IBMKbi0PWe15JeO745v1_LEFwPYR0Meta } from "/codebuild/output/src1259003470/src/src/pages/mypage/index.vue?macro=true";
import { default as indexh2oX7gce0OXnICSTqbPN09ojf0eJSRImayLz1JPrLhsMeta } from "/codebuild/output/src1259003470/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_938kViLew45pk9WWimu_45ukQAwTF7Js9KFiziItwki5hiYMeta } from "/codebuild/output/src1259003470/src/src/pages/parking/[id].vue?macro=true";
import { default as indexUp2LXiv8CommRZ7_eb52IdIW9ZURnNf6n12LiwFGTt8Meta } from "/codebuild/output/src1259003470/src/src/pages/history/index.vue?macro=true";
import { default as indexdju7hgJWqFS9wCn8wPlmaU37UgwFkcmqvXbNv37cfeoMeta } from "/codebuild/output/src1259003470/src/src/pages/monthly/index.vue?macro=true";
import { default as indext_45CpgTajvaytTGj_45TZPeLwnzqIuU9R9_45Pg7YbEE6ohYMeta } from "/codebuild/output/src1259003470/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexDxzi5TzjHIbVW71htPFSAC7uPYdShu7chlj1Fmx6reYMeta } from "/codebuild/output/src1259003470/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavibLgQmC2mGO8jT_45kHPDNiL8wbRfYwRqjzTXw64sPuR6kMeta } from "/codebuild/output/src1259003470/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editQgGq_bdEuwfYel1FvkwsssY08CpmgF_aQpm4kw9_f6kMeta } from "/codebuild/output/src1259003470/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement75KMphkBuYDKse6yrl2KzAigS2zyT0wqc1Fq1SiWAewMeta } from "/codebuild/output/src1259003470/src/src/pages/pass-agreement.vue?macro=true";
import { default as index8IaNmh_6qZBnA3KZumW1nsA_sIHioXAOOg3YxZKLV6EMeta } from "/codebuild/output/src1259003470/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dQEpctsDdm4dhL_fxz0w98GEbjENh12MaBSCzjbbBxzUMeta } from "/codebuild/output/src1259003470/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmjFOWlc6z3P2DbckPsIjPC0atqGy_45NDQw28M5_45zHKjcMMeta } from "/codebuild/output/src1259003470/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexUupoqimv1eGwjir_45xS_453UDN0HRtOOEYcBsenDBJRxNgMeta } from "/codebuild/output/src1259003470/src/src/pages/card/create/index.vue?macro=true";
import { default as index2nk0K6WWZKzXCN_45woMiO3d5FXPxpKCu4FbGbvvI2_45fsMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmHYdfA7GhabxMtOZ4h6AK95qKoPboe3BsF23Jm1BGwX8Meta } from "/codebuild/output/src1259003470/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmqgohuI2IJIEylRfSodLk98SHgvC_2v_45LUUyGPuwLMuQMeta } from "/codebuild/output/src1259003470/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completekzkFtOCuMoDVZ98dpzWRh_455UJHdbLofH71zo4EZK_45gUMeta } from "/codebuild/output/src1259003470/src/src/pages/membership/complete.vue?macro=true";
import { default as register_y4cAT3QQmvfmMQ_j2ksYPIhuyweT3ZsH_45fy7miX94MMeta } from "/codebuild/output/src1259003470/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93_eBMjTiPVaGpjUHZA35HEt5F_cH2SCRwnzJ09nqJmy4Meta } from "/codebuild/output/src1259003470/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmTUejFkYIrgAEbV0al4lGNtGYFZZaS1I8GNFWiIwjbCIMeta } from "/codebuild/output/src1259003470/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93bENS9_45pzbVGFwKOmoR_ckGjpMHYZtIEOlkpXm1fyhcsMeta } from "/codebuild/output/src1259003470/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexElUMrBGs0ebigA4YOTtZeD1jNPFG8n7Z_45KYnm194v_8Meta } from "/codebuild/output/src1259003470/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeAnSrdkPK2YrVRSsldQ5Iy1_KU2M3ZuJ5OUEj2q9cP2kMeta } from "/codebuild/output/src1259003470/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code3JsOLLqW_45pP1Nly1nbWZj5VTZ79FNItbJjjsiD2GxkYMeta } from "/codebuild/output/src1259003470/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeJS6wtz2oEhh58rrej7Qaapf0GPac7fGgDJyy9ADPnrwMeta } from "/codebuild/output/src1259003470/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registercsI4xz4Q5GvgfHdPJ6d_452FHaDYSsT6sjviF1H3_45JEkkMeta } from "/codebuild/output/src1259003470/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeMUDbLkUlYSW9mJXDDc0bUei_nded53WDYzg53TkBRT8Meta } from "/codebuild/output/src1259003470/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexWdZTR4qNej01O2v1_45VAiwKQDc0KifNoJramMbBTJ4pYMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmVwP_45euKt4QPlFchOOv8lGHlCYq2LgFc4u0FeHigpq_AMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete_4569QVdF_45VBmoaCFzBJ47JJSFUZsa89f442wsy3u3LkwMeta } from "/codebuild/output/src1259003470/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexyyXYfViUK0Fir9vnqe4vT4HWafH_45rIHANEzNEQNG2ocMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93Dykz2bwmj_LOgz2TBdm5iOa7wy5oFQhSSqAq4GPsTlAMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeYNgXqqjYEpM7khNr0b_wcjAWKqslCmvgCCIM1EdqcgcMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasrw7P7HO9a_tD4xnJ2jnHMgF_45AWUYXwfJF_45zQ_45jFbBLMMeta } from "/codebuild/output/src1259003470/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleHZb_4530vup_45IRzcS7qponLlczmw9HAKR93YyR16qzUJsMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailc8QSYRIGG7YLxKR_45vQm6nF20hzw95S3EU8SYIm0d73cMeta } from "/codebuild/output/src1259003470/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmFWEWf5gElD2rJktTsKkbOI3VTfMZTltlEGoqxNN0OmcMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent9HbI4VmQ75FaF0NAHwwOJ_45IzB7JVcUNOxnTffOHPp6MMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmO28Z8BFAHTVZEIc_45gLF8sufo1_455cy38ZcdxiumuS8FUMeta } from "/codebuild/output/src1259003470/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate9Jh_64WKmjDmKRFpL5sFyE5tBSjEonWwWQs_45c5LspCAMeta } from "/codebuild/output/src1259003470/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete4k0T3YGIb_45bmw163y3_qY_451rcbctlcdcc_6ljumca50Meta } from "/codebuild/output/src1259003470/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code3gjHXPnjFZaae_45GwcjBYJQYq5qkzqkkSh5GhSQoE7qUMeta } from "/codebuild/output/src1259003470/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordFkQjHegO9agcsp3y7jUdobksHNfbTSrrHBgw4r2tRv4Meta } from "/codebuild/output/src1259003470/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasXWK1U8cLui_45boyiHJSAMMains6fy2_QWNxsgBApaEEQMeta } from "/codebuild/output/src1259003470/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register7TCjlmJAwEVLFXPFoI4OVIjYNwi2DSLZUeCzRno6mhQMeta } from "/codebuild/output/src1259003470/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeN7RAly3wV3GqC2g1s1EdmAuphziRNqtrWRO_R7jXaDgMeta } from "/codebuild/output/src1259003470/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexLNUpi7eElW7hQDud40kpEgLeAqcimAnLrtf90U1zhlYMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexkQjGujEcfFZj5Mc4zHX0b_45xJk8GgFG6M3dIsRYDduiUMeta } from "/codebuild/output/src1259003470/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexAFk_BxNkf6eJSmdf_45FFTkrX4_iHxNg7Ej0dVTHTvDGIMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index81gCR36pDBgJgpWyUmeVYBTDT5ZsnFlvisOuYIt3Sk4Meta } from "/codebuild/output/src1259003470/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update6dkqmS7jvI9NhnGIoQl06GY9DQmGdtZwXjBl8jc7W1gMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeODo8H6FJ7fm9VpL04_bqUHrTC__45d3WpwXXSJvE2QpuwMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmwRauvEmH_1AU6_45xt6efZkcxPP7Ne3zqVtzv3UxmTruoMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexStruBpwlDZzV9xWAD33scESNB1njlfNdn9suam799vgMeta } from "/codebuild/output/src1259003470/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completebBOA_u1rp1_PP6rHtRVMtYScJRVb6cXlAygKRmo6InkMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateu8OXspp9q1Mt3_SGWSzbPZbaEeut9TkSei1PxN0GCwIMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index1baEQl1CM6_45T9TX_oMuBf6cyezIHl5kCBsd4vTKX_45o8Meta } from "/codebuild/output/src1259003470/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexhkr7d3Woeqqq0brH0nnU8jrgX84aVe1x4ih5uxbHz2EMeta } from "/codebuild/output/src1259003470/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completetMSLJuCH7eS2Mw00eed_45aOqtOaVXspln0k0qkJSubXIMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexPwLZuTzOhTVN_45x9O_45XmWkqTmIQNn3S_45XMJVtkhxQUZsMeta } from "/codebuild/output/src1259003470/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeGwDpYkpetwmz5LQYTKGGX_VUIu0wll29U_45iNQtYXN7IMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexe8Hc_45orlinsud2PEaf36hXZSK6Wl2uz_45ZxATWxlI3EQMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexquRYe01Ut059cJIlhmM3Kd6ZcnI1fuUgPhmrs5yhhvcMeta } from "/codebuild/output/src1259003470/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexGEmMw9gwrtj2pL0UbDwPrl_45z6gYwzQXMvxJ9AcPdZAMMeta } from "/codebuild/output/src1259003470/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatezt3XV80tmOW_45_454uBtrhjHh1KOpqa1QjqveVLeJ1hIuMMeta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmhmpOmEXWJo8TbxDz6EWZCiu4bqXgxTBVZ4O_45xGQDdW0Meta } from "/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuHWauu1q9jBQKos7h_45PpjzhEEZ9va5midatwWyTYi3_QMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexxXYQvohAEj6SP1l5IahKOw4VxPIy2LDiavm_u_pNTDIMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexCfNVJPVTnvRE_45lioEIBmE33zvDy3Kl1F_45i3T8EHqsAIMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexUp2LXiv8CommRZ7_eb52IdIW9ZURnNf6n12LiwFGTt8Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indext_45CpgTajvaytTGj_45TZPeLwnzqIuU9R9_45Pg7YbEE6ohYMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexDxzi5TzjHIbVW71htPFSAC7uPYdShu7chlj1Fmx6reYMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexUupoqimv1eGwjir_45xS_453UDN0HRtOOEYcBsenDBJRxNgMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmHYdfA7GhabxMtOZ4h6AK95qKoPboe3BsF23Jm1BGwX8Meta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmqgohuI2IJIEylRfSodLk98SHgvC_2v_45LUUyGPuwLMuQMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completekzkFtOCuMoDVZ98dpzWRh_455UJHdbLofH71zo4EZK_45gUMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register_y4cAT3QQmvfmMQ_j2ksYPIhuyweT3ZsH_45fy7miX94MMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmTUejFkYIrgAEbV0al4lGNtGYFZZaS1I8GNFWiIwjbCIMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeAnSrdkPK2YrVRSsldQ5Iy1_KU2M3ZuJ5OUEj2q9cP2kMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code3JsOLLqW_45pP1Nly1nbWZj5VTZ79FNItbJjjsiD2GxkYMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeJS6wtz2oEhh58rrej7Qaapf0GPac7fGgDJyy9ADPnrwMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registercsI4xz4Q5GvgfHdPJ6d_452FHaDYSsT6sjviF1H3_45JEkkMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmVwP_45euKt4QPlFchOOv8lGHlCYq2LgFc4u0FeHigpq_AMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete_4569QVdF_45VBmoaCFzBJ47JJSFUZsa89f442wsy3u3LkwMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexyyXYfViUK0Fir9vnqe4vT4HWafH_45rIHANEzNEQNG2ocMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeYNgXqqjYEpM7khNr0b_wcjAWKqslCmvgCCIM1EdqcgcMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleHZb_4530vup_45IRzcS7qponLlczmw9HAKR93YyR16qzUJsMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailc8QSYRIGG7YLxKR_45vQm6nF20hzw95S3EU8SYIm0d73cMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmFWEWf5gElD2rJktTsKkbOI3VTfMZTltlEGoqxNN0OmcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent9HbI4VmQ75FaF0NAHwwOJ_45IzB7JVcUNOxnTffOHPp6MMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmO28Z8BFAHTVZEIc_45gLF8sufo1_455cy38ZcdxiumuS8FUMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete4k0T3YGIb_45bmw163y3_qY_451rcbctlcdcc_6ljumca50Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code3gjHXPnjFZaae_45GwcjBYJQYq5qkzqkkSh5GhSQoE7qUMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordFkQjHegO9agcsp3y7jUdobksHNfbTSrrHBgw4r2tRv4Meta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register7TCjlmJAwEVLFXPFoI4OVIjYNwi2DSLZUeCzRno6mhQMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeN7RAly3wV3GqC2g1s1EdmAuphziRNqtrWRO_R7jXaDgMeta || {},
    component: () => import("/codebuild/output/src1259003470/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1259003470/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]